import {t} from '../../../../common/getTranslations';
import {requestContext} from '../../../../common/requestContext';
import useTypedSelector from '../../../../common/useTypedSelector';
import {NoItem} from '../../../../design-system/organisms/NoItem/NoItem';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';
import {ReactQueryInfiniteType} from '../../../../reactQuery/CodegenReactQueryType.type';
import {ReactQueryFetcher} from '../../../../reactQuery/ReactQueryFetcher';
import {ReactQueryInfiniteFetcher} from '../../../../reactQuery/ReactQueryInfiniteFetcher';
import {
  useBlockUserListQuery,
  useInfiniteBestCommentListQuery,
} from '../../../../wrapper';
import {CommentItemContainer} from '../../../comment/detail/container/CommentItemContainer';

export interface CommentBestListContainerProps {
  seriesId: number;
  productId?: number;
  isContentHome?: boolean;
}

export function CommentBestListContainer({
  seriesId,
  productId,
  isContentHome,
}: CommentBestListContainerProps) {
  const {isMobile} = requestContext.requestInfo.display;
  const user = useTypedSelector(state => state.user.user);
  return (
    <div className="flex flex-1 flex-col">
      <ReactQueryFetcher
        reactQuery={useBlockUserListQuery}
        options={{enabled: !!user}}
      >
        <ReactQueryInfiniteFetcher
          reactQuery={useInfiniteBestCommentListQuery}
          variables={{
            bestCommentListInput: {
              page: 0,
              seriesId,
              productId,
            },
          }}
          options={{
            initialPageParam: {
              bestCommentListInput: {
                page: 0,
                seriesId,
                productId,
              },
            },
            getNextPageParam: (lastPage, pages) => {
              return lastPage.bestCommentList?.isEnd
                ? undefined
                : {
                    bestCommentListInput: {
                      page: pages.length,
                      seriesId,
                      productId,
                    },
                  };
            },
          }}
          type={
            !isMobile && isContentHome
              ? ReactQueryInfiniteType.ArrowDown
              : ReactQueryInfiniteType.InfinityScroll
          }
          onStartFetchNextPage={e =>
            LOG_CLICK_EVENT('댓글목록_가져오기_클릭', e)
          }
        >
          {bestCommentList => {
            if (
              bestCommentList &&
              bestCommentList.pages[0].bestCommentList?.commentList.length === 0
            )
              return (
                <NoItem isMobile={isMobile}>{t('comment_best_blank')}</NoItem>
              );

            return bestCommentList?.pages.map(page =>
              page.bestCommentList?.commentList.map(item => (
                <CommentItemContainer
                  seriesId={seriesId}
                  productId={productId}
                  item={item}
                  key={item.commentUid}
                  isProductComment={!!productId}
                />
              ))
            );
          }}
        </ReactQueryInfiniteFetcher>
      </ReactQueryFetcher>
    </div>
  );
}
